module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noOptions":"No users available","noResult":"No users were found"},"de":{"noOptions":"Keine Benutzer verfügbar","noResult":"Kein Benutzer gefunden"},"fr":{"noOptions":"Aucun utilisateur disponible","noResult":"Aucun utilisateur n\u0027a été trouvé"},"it":{"noOptions":"Nessun utente disponibile","noResult":"Nessun utente è stato trovato"}}')
  delete Component.options._Ctor
}
